import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  appStoreDeleteStore,
  appStoreGetData,
  appStoreIsLoading,
  appStoreMakeRequest,
} from 'reactStore/slices/appStoreSlice';
import * as ENDPOINT from 'config/endpoint';
import PaymentInvoiceCard from './PaymentInvoiceCard/PaymentInvoiceCard';
import OrderPaymentInvoiceCard from './OrderPaymentInvoiceCard/OrderPaymentInvoiceCard';
import { turnOffEvent } from 'utils/helpers';
import { Grid, Pagination } from '@mui/material';

const LIMIT = 10;

const FinancialStatementsList = ({ type, page, setPage }) => {
  const storeName = 'financial-statements-list-store';
  const dataSource = ENDPOINT.PAYMENT_INVOICES;
  const [count, setCount] = useState(1);
  const isLoading = useSelector(appStoreIsLoading({ storeName }));
  const dispatch = useDispatch();
  const isTriggeredType = type === 'triggered';

  const list = useSelector(appStoreGetData({ storeName, def: [] }));

  useEffect(() => {
    const params = {
      data: {
        paginate: { page, limit: LIMIT },
        filter: { state: type, active: true, sort: { by: 'created_at', direction: -1 } },
      },
    };
    const mapper = (d) => {
      const { total } = d.data.meta;

      setCount(Math.ceil(total / LIMIT));
      return d.data.data;
    };

    dispatch(appStoreMakeRequest({ storeName, dataSource, mapper, params, def: [] }));

    return () => dispatch(appStoreDeleteStore({ storeName }));
  }, [dataSource, dispatch, page, type]);

  const handleChangePage = (e, page) => {
    turnOffEvent(e);
    setPage(page);
  };

  return (
    <Grid container spacing={3} justifyContent="center">
      {list?.map((item) =>
        isTriggeredType ? (
          <OrderPaymentInvoiceCard {...item} key={item.id} />
        ) : (
          <PaymentInvoiceCard {...item} key={item.id} />
        ),
      )}
      {!isLoading && count > 1 && (
        <Grid item children={<Pagination {...{ count, page }} color="primary" onChange={handleChangePage} />} />
      )}
    </Grid>
  );
};

FinancialStatementsList.propTypes = {
  type: PropTypes.string,
  page: PropTypes.string,
  setPage: PropTypes.func,
};

export default FinancialStatementsList;
